import { useDataAssignments } from "./useDataAssignments";

export const useXMLOrdersPathDropdown = () => {
  const dataAssignments = useDataAssignments();

  return dataAssignments.map(({ value }) => ({
    label: value ?? "",
    value: value ?? "",
  }));
};
